import { getSizedImageURL } from '../../core/images';
import { debounce } from '../../core/helpers';

const initSelectedColorElementsInSticky = () => {
  // Remove previous product image
  document.querySelector('[data-mobile-sticky-add-to-cart-image] [data-product-main]')?.remove();

  // Get the first product image from mobile images
  window.setTimeout(() => {
    const firstImage = document.querySelector('[data-product-mobile-images] .product-main img');
    if (firstImage) {
      const firstImageSrcResized = getSizedImageURL(firstImage.dataset.original, '500x', true);

      const container = document.querySelector('[data-mobile-sticky-add-to-cart-image]');
      if (container) {
        const div = document.createElement('div');
        div.className = 'product-main';
        div.setAttribute('data-product-main', '');
        div.innerHTML = `<img class="product-main__image" src="${firstImageSrcResized}" alt="${firstImage.getAttribute('alt')}" tabindex="0">`;
        container.appendChild(div);
      }
    }
  }, 100);

  // No need to refresh the price, sizes, add to cart UNLESS a size has already been selected
  document.querySelectorAll('[data-mobile-sticky-add-to-cart-main] [data-product-option-sizes] li.active').forEach(li => {
    li.click();
  });

  // Hide the colors from the opposite fit (uncomment and use if needed)
  // const container = document.querySelector('[data-mobile-sticky-add-to-cart-main]');
  // const selectedFit = container?.querySelector('[data-product-option-fit].active')?.dataset.fitHandle;
  // if (selectedFit) {
  //   document.querySelectorAll(`[data-product-option-color-mobile-sticky][data-plus-color="${selectedFit === 'plus'}"]`).forEach(color => {
  //     color.classList.add('inactive');
  //   });
  // }
};

let lastTouchTime = 0;
const handleAddToCartButtonClick = (e) => {
  // Prevent double trigger: if touchend just happened, ignore click
  if (e.type === 'click' && lastTouchTime && (Date.now() - lastTouchTime) < 500) return;
  if (e.type === 'touchend') lastTouchTime = Date.now();

  // Your custom event logic
  const overviewEl = document.querySelector('[data-add-to-cart]');
  if (!overviewEl) return;

  document.dispatchEvent(new CustomEvent('astr-add-to-cart', { detail: { form: overviewEl.closest('form') } }));

  setTimeout(() => {
    const mobileStickySizesElement = document.querySelector('[data-mobile-sticky-add-to-cart-sizes]');
    if (mobileStickySizesElement && mobileStickySizesElement.classList.contains('error')) {
      mobileStickySizesElement.focus();
    }

    // closeComponent();
  }, 1000);
};

export default () => {
  // document.addEventListener('astr-pdp-size-selected', () => {
  //   $('[data-mobile-sticky-add-to-cart-button]').attr('disabled', false);
  // });

  // colors_only = true when "add to cart" has been clicked but no colors has been selected yet (sizes not showing)
  const openSizes = (colors_only = false) => {
    // Always active when opened
    $('[data-mobile-sticky-add-to-cart-sizes]').addClass('active');

    initSelectedColorElementsInSticky();

    // Trigger custom event for Fit Predictor widget
    // const pdp_mobile_sizes_opened = new CustomEvent('astr-pdp-mobile-sizes-opened', { bubbles: true });
    // document.dispatchEvent(pdp_mobile_sizes_opened);
    // document.addEventListener('astr-pdp-mobile-sizes-opened', (e) => {
    //  // Custom code
    // });

    // Lock scroll
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
  };

  const closeComponent = () => {
    document.documentElement.classList.remove('mobile-sticky-add-to-cart-opened-colors');
    document.querySelector('[data-mobile-sticky-add-to-cart-closed]').classList.add('active');
    document.querySelector('[data-mobile-sticky-add-to-cart-opened]').classList.remove('active');
    document.querySelector('[data-pdp-overlay]').classList.remove('active');
    document.querySelector('[data-mobile-sticky-add-to-cart-image] [data-product-main]')?.remove();
    const fitsEl = document.querySelector('[data-mobile-sticky-add-to-cart-fits]');
    if (fitsEl) fitsEl.innerHTML = '';

    const colorsEl = document.querySelector('[data-mobile-sticky-add-to-cart-colors]');
    if (colorsEl) colorsEl.innerHTML = '';

    const sizesEl = document.querySelector('[data-mobile-sticky-add-to-cart-sizes]');
    if (sizesEl) {
      sizesEl.innerHTML = '';
      sizesEl.classList.remove('active');
    }
    document.querySelector('[data-mobile-sticky-add-to-cart-main]').removeAttribute('style');

    // Unlock scroll
    const scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);

    // Trigger scroll event to show the sticky add to cart again
    // window.dispatchEvent(new Event('scroll'));
  };

  const initFits = () => {
    const container = document.querySelector('[data-mobile-sticky-add-to-cart-main]');

    if (container.querySelector('[data-product-option-fits]') === null) {
      return;
    }

    // Custom event captured in PlusSizes
    const pdp_sticky_mobile_fits_init = new CustomEvent('astr-pdp-sticky-mobile-fits-init', { bubbles: true });
    document.dispatchEvent(pdp_sticky_mobile_fits_init);
  };

  // The following listeners with both click and touchend are legacy listeners, they will trigger double events, that's fine since they are not action elements but it would be great to update them at some point using the same method as the add to cart button below
  $(document).on('click touchend', '.sticky-add-to-cart--mobile .product-size-info', (e) => {
    e.stopPropagation();
    e.preventDefault();

    window.setTimeout(() => {
      let zindex = 999999;
      if ($('#INDWrap').length) {
        zindex = Number($('#INDWrap').css('z-index')) + 1;
      }

      $('.blocker').css('z-index', zindex);
    }, 10);
  });

  // Closes the sticky add to cart
  $(document).on('click touchend', '[data-pdp-overlay]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    closeComponent();
  });

  // Closes the sticky add to cart
  $(document).on('click touchend', '[data-mobile-sticky-add-to-cart-close]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    closeComponent();
  });

  // Select a color
  $(document).on('click touchend', '[data-product-option-color-mobile-sticky]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    const item = e.currentTarget;
    const color_handle = item.getAttribute('data-color-handle');

    document.querySelector(`[data-product-option-color][data-color-handle="${color_handle}"]`).click();
    document.querySelectorAll('[data-product-option-color-mobile-sticky]').forEach(el => el.classList.remove('active'));
    item.classList.add('active');

    // Open the size selection if not already opened
    // if (!$('[data-mobile-sticky-add-to-cart-sizes]').hasClass('active')) {
    //   openSizes();
    // }

    initSelectedColorElementsInSticky();
  });

  // Select a size
  $(document).on('click touchend', '[data-mobile-sticky-add-to-cart-sizes] [data-product-option-size]', (e) => {
    // if (e.type == 'touchend') {
    const $item = $(e.currentTarget);

    if ($item.hasClass('disabled')) {
      return;
    }

    $(`[data-product-details] [data-size-handle="${$item.data('size-handle')}"]`).trigger('click');
    $('[data-product-option-sizes-sticky] li').removeClass('active');
    $item.parent().addClass('active');
    // $('[data-mobile-sticky-add-to-cart-button]').attr('disabled', false);

    // console.log('add to cart', $item.data('size-handle'));

    /*
    window.setTimeout(() => {
      $('[data-add-to-cart]').trigger('click');
    }, 10);

    window.setTimeout(() => {
      closeComponent();
    }, 10);
    */
  });

  // Add to cart
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-sticky-add-to-cart-button]')) {
      handleAddToCartButtonClick(e);
    }
  });

  document.addEventListener('touchend', function (e) {
    if (e.target.closest('[data-mobile-sticky-add-to-cart-button]')) {
      handleAddToCartButtonClick(e);
    }
  });

  // Open the Mobile sticky add to cart
  $(document).on('click touchend', '[data-mobile-sticky-add-to-cart]', (e) => {
    if (window.theme.breakpoints.current !== 'mobile' && window.theme.breakpoints.current !== 'tablet') {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    // const $item = $(e.currentTarget);

    // $('html, body').animate({ scrollTop: 0 }, 'fast');
    document.querySelectorAll('[data-mobile-sticky-add-to-cart-closed]').forEach(el => el.classList.remove('active'));
    document.querySelectorAll('[data-mobile-sticky-add-to-cart-opened]').forEach(el => el.classList.add('active'));
    document.querySelectorAll('[data-pdp-overlay]').forEach(el => el.classList.add('active'));

    // Fits element if any
    const optionFit = document.querySelector('[data-option-fit]');
    const mobileFits = document.querySelector('[data-mobile-sticky-add-to-cart-fits]');
    if (optionFit && optionFit.classList.contains('active')) {
      if (mobileFits) {
        mobileFits.innerHTML = optionFit.innerHTML;
        mobileFits.classList.add('active');
        initFits();
      }
    } else if (mobileFits) {
      mobileFits.remove();
    }

    // Only show the colors part if not selected
    // const show_colors_only = $('[data-selected-color-label]').hasClass('unselected');
    // $('[data-mobile-sticky-add-to-cart-main]').height(200);

    document.documentElement.classList.add('mobile-sticky-add-to-cart-opened-colors');

    // Duplicate the color element data-option-color into data-mobile-sticky-add-to-cart-colors
    const optionColor = document.querySelector('[data-option-color]');
    const mobileColors = document.querySelector('[data-mobile-sticky-add-to-cart-colors]');
    if (optionColor && mobileColors) {
      let colors_html = optionColor.innerHTML;
      colors_html = colors_html.replaceAll('data-product-option-color', 'data-product-option-color-mobile-sticky');
      mobileColors.innerHTML = colors_html;
    }

    // Clicking a size will automatically add the variant to the cart
    const optionSize = document.querySelector('[data-option-size]');
    const mobileSizes = document.querySelector('[data-mobile-sticky-add-to-cart-sizes]');
    if (optionSize && mobileSizes) {
      let sizes_html = optionSize.innerHTML;
      sizes_html = sizes_html.replace('data-product-option-sizes', 'data-product-option-sizes-sticky');
      sizes_html = sizes_html.replaceAll('product-option__size', 'product-option__size--mobile');
      sizes_html = sizes_html.replaceAll('product-option__size--mobiles', 'product-option__sizes--mobile');
      sizes_html = sizes_html.replace('product-option__sizes--mobile-error', 'product-option__sizes-error--mobile');
      sizes_html = sizes_html.replace('<ul', '<ul class="product-option__sizes"');
      mobileSizes.innerHTML = sizes_html;

      // Remove select elements
      mobileSizes.querySelectorAll('select').forEach(el => el.remove());

      // Update title
      const title = mobileSizes.querySelector('.product-option__title');
      if (title) title.textContent = 'Choose your size';
    }

    // "Don't see your size" Klaviyo widget
    const klaviyo = document.querySelector('.klaviyo-bis-trigger');
    if (klaviyo && mobileSizes) {
      mobileSizes.appendChild(klaviyo.cloneNode(true));
    }

    openSizes();
  });

  // mobile-sticky-add-to-cart is not on the gift card pages
  window.addEventListener('scroll', debounce(() => {
    const $satc = $('[data-mobile-sticky-add-to-cart-main]');
    if (!$satc.length) {
      return;
    }

    // console.log($satc.offset().top, $('footer.shopify-section-group-footer-group').offset().top);

    const needsclick_widget = document.querySelector('.needsclick');

    // Show the mobile sticky add to cart when reaching the end of product-actions
    if ($(window).scrollTop() >= $('[data-product-details] .product-actions').offset().top + $('[data-product-details] .product-actions').outerHeight() - 100) {
      $satc.css({ 'opacity': 1, display: 'block' });
      $satc.attr('aria-hidden', false);
      $satc.find('[data-add-to-cart-available]').removeClass('visually-hidden');

      if (needsclick_widget) {
        needsclick_widget.style.display = 'none';
        needsclick_widget.setAttribute('aria-hidden', true);
        needsclick_widget.setAttribute('tabindex', '-1');
      }
    } else {
      $satc.css({ 'opacity': 0, display: 'none' });
      $satc.attr('aria-hidden', true);

      if (needsclick_widget) {
        needsclick_widget.style.display = 'block';
        needsclick_widget.setAttribute('aria-hidden', false);
        needsclick_widget.setAttribute('tabindex', '0');
      }
    }

    // Hide the mobile sticky add to cart when reaching the footer
    if ($satc.offset().top >= $('footer.shopify-section-group-footer-group').offset().top) {
      if (!$satc.hasClass('not-visible')) {
        $satc.addClass('not-visible');

        window.setTimeout(() => {
          // $satc.addClass('not-visible--none');
          $('.template-pdp main').css('z-index', 2);
        }, 250);
      }
    } else if ($satc.hasClass('not-visible')) {
      // $satc.removeClass('not-visible--none');
      $('.template-pdp main').css('z-index', 3);
      $satc.removeClass('not-visible');
    }
  }, 10));
};
